import React, { Component } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import classNames from "classnames";

class Persontags extends Component {
  render() {
    const tags = this.props.Tags;
    if (!tags) {
      return;
    }

    const labels = {
      dead: "Død",
      sport: "Idrettsprofil",
      famous: "Kjendis",
      mentioned: "Viktig",
      rich: "Rik",
      old: "Gammel"
    };

    return (
      <React.Fragment>
        {Object.keys(tags).map(function(key, index) {
          if (tags[key]) {
            return (
              <Tooltip key={index} title={labels[key]}>
                <i className={classNames("tag", key)}></i>
              </Tooltip>
            );
          }
          return <i key={index} />;
        })}
      </React.Fragment>
    );
  }
}
export default Persontags;
